import { jsxs as t, Fragment as f, jsx as e } from "@emotion/react/jsx-runtime";
import { memo as h, useState as c } from "react";
import { IconButton as p, FontAwesomeIconsPartooUsed as u, IconPrefix as T, Drawer as w, Stack as g, Text as C, Tabs as a } from "@partoohub/ui";
import { alerts as b, informations as x } from "./helpers.js";
import { NotificationButton as I, NotificationStatus as S, StickyContainer as _, AlertContentContainer as k } from "./NotificationPanel.styled.js";
import { AlertCard as N } from "./subComponents/AlertCard/AlertCard.js";
import { InformationsCard as A } from "./subComponents/InformationsCard/InformationsCard.js";
const D = h(() => {
  const [n, i] = c(!1), [r, l] = c(0), s = () => {
    i(!n);
  }, d = () => {
    i(!1);
  }, m = (o) => l(o);
  return /* @__PURE__ */ t(f, { children: [
    /* @__PURE__ */ t(I, { onClick: s, children: [
      /* @__PURE__ */ e(p, { dataTrackId: "show_notification__icon_button", "aria-label": "Show notifications", icon: [u.faBell, T.REGULAR], appearance: "outlined" }),
      /* @__PURE__ */ e(S, {})
    ] }),
    /* @__PURE__ */ e(w, { dataTrackId: "notification_panel__drawer", isOpen: n, onHide: d, children: /* @__PURE__ */ t(g, { gap: "8px", children: [
      /* @__PURE__ */ t(_, { gap: "8px", children: [
        /* @__PURE__ */ e(C, { variant: "heading5", children: "Notifications" }),
        /* @__PURE__ */ t(a, { dataTrackId: "", selected: r, onChange: m, children: [
          /* @__PURE__ */ e(a.Tab, { value: 0, counter: 3, children: "Alertes" }, "alertes"),
          /* @__PURE__ */ e(a.Tab, { value: 1, counter: 1, children: "Informations" }, "informations")
        ] })
      ] }),
      r === 0 ? /* @__PURE__ */ e(k, { gap: "8px", children: b?.items.map((o) => /* @__PURE__ */ e(N, { item: o }, `alert_${o.id}`)) }) : /* @__PURE__ */ e(A, { informations: x })
    ] }) })
  ] });
});
D.displayName = "NotificationPanel";
export {
  D as NotificationPanel
};
